import React, { PureComponent, createRef } from 'react';
import './CheckoutTrustpilot.scss';

export class CheckoutTrustpilot extends PureComponent {

    private readonly refWidgetDesktop = createRef<HTMLDivElement>();
    private readonly refWidgetMobile = createRef<HTMLDivElement>();

    componentDidMount() {
        let trustpilot = window['Trustpilot'] as any;
        if (trustpilot) {
            trustpilot.loadFromElement(this.refWidgetDesktop.current, true);
            trustpilot.loadFromElement(this.refWidgetMobile.current, true);
        }
    }

    render(): JSX.Element {
        return (
            <div className='checkout-trustpilot'>
                <div
                    ref={this.refWidgetDesktop}
                    className='trustpilot-widget checkout-trustpilot__desktop-widget'
                    data-locale='en-GB' data-template-id='5419b6ffb0d04a076446a9af'
                    data-businessunit-id='52a887ce00006400057794e1'
                    data-style-height='20px'
                    data-style-width='100%'
                    data-theme='dark'></div>
                <div className='checkout-trustpilot__padlock'>
                    <i className='sa sa-lock'></i>
                </div>
                <div
                    ref={this.refWidgetMobile}
                    className='trustpilot-widget checkout-trustpilot__mobile-widget'
                    data-locale='en-GB'
                    data-template-id='5419b732fbfb950b10de65e5'
                    data-businessunit-id='52a887ce00006400057794e1'
                    data-style-height='50px'
                    data-style-width='100%'
                    data-theme='dark'></div>
            </div>
        );
    }
}